import { Component } from 'react';
import OpportunityItem from '../../../Domain/OpportunityItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import OpportunityService from '../../../Services/opportunityService';
import OpportunityValidation from "./OpportunityValidation"

class AdminEditOpportunityWindowDescription extends Component {
    static titleForCreate = "Add New Opportunity";
    static titleForEdit = "Edit Opportunity";
    static ComponentName ="Opportunity"

    static itemType = OpportunityItem;
    static serviceFunction = (edited) => OpportunityService.PostEndDate(edited);

    static pagesInGeneralEditWizzard = [
        {            
            label: "Estimates",
            fields: [
                { fieldName: "ActualEndOnOverrid", label: "Actual End On", className: "col-12", type: InputTypesEnum.Date, validityChecker: OpportunityValidation.ActualEndOnAdminEdit },            
            ]
        }
    ]
 }

export default AdminEditOpportunityWindowDescription;
